import { render, staticRenderFns } from "./Billboard.vue?vue&type=template&id=076d135a&scoped=true"
import script from "./Billboard.vue?vue&type=script&lang=js"
export * from "./Billboard.vue?vue&type=script&lang=js"
import style0 from "./Billboard.vue?vue&type=style&index=0&id=076d135a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076d135a",
  null
  
)

export default component.exports